import {
  createLessonPlan,
  createNodeList,
  createNoteNode,
} from '../nodeCreationHelpers'
import {
  createTable,
  PARAGRAPH_SPACING,
  wrapB,
  wrapSpan,
} from '../html_utility'
import { IUnitLessonParams } from './types'
import { parseHtmlString } from 'shared/utils'
import {
  getMetadataValueForKey,
  getWhereGoingForKey,
  htmlTransform,
  removeAllClassAndStyles,
  unStyledHtml,
} from './gDriveUtils'
import { INoteNode } from '../../components/ingestion/IngestedTree'

export function additionalTeacherGuidance(params: IUnitLessonParams) {
  return [
    createNodeList(
      {
        title: 'Additional Teacher Guidance',
      },
      [assessmentOpportunities(params), whereWeGoing(params)],
    ),
  ]
}

function assessmentOpportunities(params: IUnitLessonParams) {
  return createLessonPlan(
    {
      title: 'Lesson Assessment Opportunities',
    },
    [
      createNoteNode({
        title: 'Lesson Assessment Opportunities',
        value: assessmentOppTable(params),
        studentFacing: false,
      }),
    ],
  )
}

function whereWeGoing({ lessonDoc: { tableContent } }: IUnitLessonParams) {
  const whereGoing = getWhereGoingForKey(
    'where-going',
    tableContent,
    unStyledHtml,
  )
  const whereNotGoing = getWhereGoingForKey(
    'where-not-going',
    tableContent,
    unStyledHtml,
  )
  const nodes: INoteNode[] = []
  if (whereGoing) {
    nodes.push(
      createNoteNode({
        title: 'Where We Are Going',
        value: whereGoing.replaceAll('<p><span></span></p>', PARAGRAPH_SPACING),
        studentFacing: false,
      }),
    )
  }
  if (whereNotGoing) {
    nodes.push(
      createNoteNode({
        title: 'Where We Are NOT Going',
        value: whereNotGoing.replaceAll(
          '<p><span></span></p>',
          PARAGRAPH_SPACING,
        ),
        studentFacing: false,
      }),
    )
  }
  return createLessonPlan(
    {
      title: 'Where We Are Going and NOT Going',
    },
    nodes,
  )
}

function assessmentOppTable(params: IUnitLessonParams) {
  const willDoParts = parseOutParts(
    getMetadataValueForKey(
      'will-do',
      params.lessonDoc.tableContent,
      htmlTransform,
    ),
  )

  const guidanceParts = parseOutParts(
    getMetadataValueForKey(
      'assessment-guidance',
      params.lessonDoc.tableContent,
      htmlTransform,
    ),
  )

  const headerStyle = "color: #000000; font-family: 'Lexend Deca', sans-serif;"
  const rows = [
    [
      wrapSpan(wrapB('Lesson Level Performance Expectations'), {
        style: headerStyle,
      }),
      wrapSpan(wrapB('Assessment Guidance'), { style: headerStyle }),
    ],
  ]

  for (let i = 0; i < Math.max(willDoParts.length, guidanceParts.length); i++) {
    rows.push([willDoParts[i] ?? '', guidanceParts[i] ?? ''])
  }

  return createTable(rows, {
    colWidths: [50, 50],
    tableStyle: {
      style: 'border-collapse: collapse; width: 100%;',
      border: '1',
    },
    cellStyle(row) {
      if (row === 0) {
        return {
          style: 'vertical-align: top; text-align: center;',
        }
      }
      return {
        style: 'vertical-align: top;',
      }
    },
  })
}

function parseOutParts(content: string) {
  const startsWithPattern = /^[0-9]{1,2}\.[A-Z]/
  const component = parseHtmlString(content)
  removeAllClassAndStyles(component.body, { filterTags: ['li'] })
  let nextSeparator = ''
  const parts = Array.from(component.body.children).reduce<string[]>(
    (acc, child) => {
      if (child.tagName.toLowerCase() === 'p') {
        nextSeparator = PARAGRAPH_SPACING
      } else {
        nextSeparator = ''
      }
      if (child.textContent && startsWithPattern.test(child.textContent)) {
        acc.push(child.outerHTML)
        return acc
      }
      const lastItem = acc.pop() ?? ''
      const separator = lastItem ? nextSeparator : ''
      return [...acc, lastItem + separator + child.outerHTML]
    },
    [],
  )
  return parts
}
